module.exports = __webpack_public_path__ + "static/media/First Bank of Nigeria.9b8a7686.png";